module.exports = __webpack_public_path__ + "static/media/why_pt.ed3f7af3.vtt";